module.exports = __webpack_public_path__ + "static/spinner-c79f33c6a15c178b58e8b943bc550f72.gif";